import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceCollectionRecord } from '@common/data-models/service/service-collection-record';
import { ServiceResponse } from '@common/data-models/service/service-response';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { Util } from '@common/utils/util';

@Injectable({ providedIn: 'root' })
export class PublicationService {
    constructor(public nomWebServicesJson: NomWebServicesJson) {}

    public async publishPublicationList(
        database: string,
        path: string,
        copyFromId: string,
        copyFromPath: string,
        linkToParent: boolean,
        fields: { [id: string]: any }
    ): Promise<ServiceResponse<StorytellingPublicationListRecord>> {
        let response: HttpResponse<any> = null;
        if (fields) {
            Util.escapeSpecialCharsForFileName(fields);
            fields.CreatedBy = `CreatedBy.${this.nomWebServicesJson.UserId}`;
        }
        try {
            const requestParams = {
                database,
                path,
                dateTime: '',
                user: this.nomWebServicesJson.UserId,
                fieldsToUpdate: this.nomWebServicesJson.convertor.toENPSFields(fields),
                templateGuid: copyFromId,
                templateProgramId: copyFromPath,
                linkToParent,
            };
            response = await this.nomWebServicesJson.put('/api/Publication', requestParams, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
                }),
                responseType: 'json',
                observe: 'response',
            });
        } catch (error) {
            this.nomWebServicesJson.showErrorModal({
                message: 'Unable to publish',
                detailMessage: `Unable to publish. \n\rStackTrace: PublicationService.publishPublicationList(); \n\rError: ${error}`,
            });
            return new ServiceResponse<StorytellingPublicationListRecord>(false, `Unable to create topic ${error.toString()}`);
        }
        const serviceRecord = ServiceCollectionRecord.instance(response.body);
        serviceRecord.instantiateChildren();

        const publicationRecord = this.nomWebServicesJson.convertor.fromServiceCollectionRecordV2<StorytellingPublicationListRecord>(serviceRecord);
        // await DataStore.setCollection(publicationRecord, true);
        return new ServiceResponse<StorytellingPublicationListRecord>(true, publicationRecord);
    }
}
